<script setup lang="ts">
import { useComputedAttrs, useComputedInput, useEventsToValidate } from './helpers'
import { RadioGroupInputProps } from './types'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<RadioGroupInputProps>()
const emit = defineEmits(['update:modelValue', 'change', 'blur', 'validate', 'invalid'])
const input = useComputedInput(props, emit)
const attrs = useComputedAttrs(props, 'radio-group')
const events = useEventsToValidate(emit)
</script>

<template>
  <div v-for="option in props.options" :key="`${attrs.id}-${option.label}`" class="radio-group-item">
    <input
      class="radio-input"
      v-model="input"
      v-autofocus="props.autofocus"
      v-bind="attrs"
      :id="`${attrs.id}-${option.label}`"
      :value="option.value"
      :checked="option.value === input"
      type="radio"
      :aria-required="props.required"
      :aria-invalid="props.invalid"
      v-on="events"
    />
    <label class="label" :for="`${attrs.id}-${option.label}`">
      {{ option.label }}
    </label>
  </div>
</template>

<style scoped>
.radio-group-item {
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-right: 16px;
  }

  label {
    margin: 0;
    font-family: var(--font-family-body);
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-regular);
    line-height: var(--line-height-body);
    color: var(--c-input-text);
    cursor: pointer;
  }
}
</style>
